import styled from "@emotion/styled";

export const StyledNMEAOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  z-index: 10;
`;

export const StyledNMEAModalContainer = styled.div<{ theme: any }>`
  background-color: ${({ theme }) => theme.colors.background[0]};
  border: 2px solid ${({ theme }) => theme.colors.inputBorder[0]};
  padding: 18px;
  border-radius: 7px;
  max-width: 60%;
  margin: 50px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
`;
